export default {
  logout: '退出登录',
  language: '语言',
  collapse: '收起',
  welcome: '欢迎',
  download: '下载',
  delete: '删除',
  upload: '上传',
  submit: '提交',
  cancel: '取消',
  close: '关闭',
  confirm: '确认',
  ok: '好的',
  edit: '编辑',
  save: '保存',
  reset: '重置',
  search: '搜索',
  view: '查看',
  detail: '详情',
  success: '成功',
  failed: '失败',
  loading: '加载中...',
  uploading: '上传中...',
  downloading: '下载中...',
  downloadStarted: '开始下载',
  actions: '操作',
  downloadSuccess: '下载成功',
  deleteSuccess: '删除成功',
  uploadSuccess: '上传成功',
  uploadFailed: '上传失败',
  chooseFile: '选择文件',
  chooseFileFromCompany: '请从企业常用资料中选择需要的文件',
  addFile: '添加文件',
  manageFiles: '管理资料',
  emptyFileMessage: '尚未添加，请先管理企业常用资料',
  fileName: '文件名称',
  uploadTime: '上传时间',
  fileSize: '文件大小',
  prev: '上一步',
  next: '下一步',
  saveAndOut: '保存并退出',
  tableStats: '共计: #total# 条',
  fileFormatNotSupported: '文件格式不支持，请上传 {0} 格式的文件',
  fileSizeExceeded: '文件大小不能超过 {0} MB',
  confirmLeave: {
    title: '确认离开',
    content: '修改尚未保存，确定要离开吗？',
  },
  confirmDeleteEmployee: {
    title: '确认删除员工',
    content: '删除后不可恢复，确定删除员工「{0}」吗？',
  },
  cannotDeleteEmployee: {
    title: '无法删除员工',
    content: '该员工存在未结束的签证任务，无法删除。',
    confirm: '好的',
  },
  confirmDeleteFile: {
    title: '确认删除文件',
    content: '删除后不可恢复，确定删除文件「{0}」吗？',
  },
  deleteConfirm: {
    title: '确认删除',
    taskContent: '删除后不可恢复，确定删除任务「{name}-{number}」吗？',
  },
  tokenExpired: '登录已过期，请重新登录',
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  cancelSuccess: '取消成功',
  confirmDelete: '确认删除',
  operationFailed: '操作失败',
  mapDialog: {
    title: '地图定位',
    searchPlaceholder: '搜索地址',
    noAddressSelected: '未选择地址',
    confirmLocationTip: '请确认位置点，否则会影响求职者导航',
    addressUpdated: '地址已更新',
    searchAddressFirst: '请先在搜索框中输入地址',
  },
  addressSelector: {
    provincePlaceholder: '都道府县',
    detailPlaceholder: '详细地址: 包含区郡、市町村区、町丁、字、其他、建地等信息',
    mapLocation: '地图定位',
  },
  pleaseSelect: '请选择',
  to: '至',
  startDate: '开始日期',
  endDate: '结束日期',
  total: '共计',
  items: '条',
  fetchFailed: '获取数据失败',
  loadFailed: '加载失败',
  deleteConfirmMessage: '删除后不可恢复，确定要删除吗？',
  warning: '警告',
  deleteFailed: '删除失败',
  addSuccess: '添加成功',
  imgUpload: {
    view: '查看',
    download: '下载',
    viewExample: '查看示例',
    downloadTemplate: '下载模板',
    fileFormatNotSupported: '文件格式不支持，请上传 {formats} 格式的文件',
    onlyImageAllowed: '只能上传图片文件',
    fileTooLarge: '文件大小不能超过 {size}',
    downloadSuccess: '下载成功',
    loadFailed: '图片加载失败',
  },
  yes: '是',
  no: '否',
  noData: '无数据',
  currency: {
    jpy: '日元',
  },
  units: {
    days: '天',
    hours: '小时',
    people: '人',
    years: '年',
    months: '个月',
  },
  noAccessPermission: '无访问权限',
  nextDay: '次日',
};
